"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccountAuthenticationModal = AccountAuthenticationModal;
const jsx_runtime_1 = require("react/jsx-runtime");
const elements_1 = require("@src/components/elements");
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const auth_context_1 = require("@src/context/auth-context");
const Api = __importStar(require("@src/api"));
const types_1 = require("@src/types");
const useSSRFetch_1 = require("@src/hooks/useSSRFetch");
const login_form_1 = __importDefault(require("../login-form"));
function AccountAuthenticationModal() {
    const { isModalOpen, setIsModalOpen, authModalPromise } = (0, auth_context_1.useAuthContextValue)();
    const [loginError, setLoginError] = react_1.default.useState(null);
    const SSRFetchClient = (0, useSSRFetch_1.useSSRFetchClient)();
    const onSubmit = react_1.default.useCallback(async (data) => {
        try {
            const account = await Api.Auth.login({ email: data.email, password: data.password });
            SSRFetchClient.invalidateSSRContext(useSSRFetch_1.SSRFetchConfig.account.key);
            authModalPromise.resolve(account);
            setIsModalOpen(false);
        }
        catch (err) {
            setLoginError(err);
        }
    }, [authModalPromise]);
    const onOAuthSuccess = react_1.default.useCallback((account) => {
        authModalPromise.resolve(account);
        setIsModalOpen(false);
    }, [authModalPromise]);
    return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: (0, jsx_runtime_1.jsxs)(elements_1.Modal, { centered: true, visible: isModalOpen, footer: null, onCancel: () => {
                authModalPromise.reject(types_1.AccountErrorCode.login_canceled);
                setIsModalOpen(false);
            }, children: [(0, jsx_runtime_1.jsx)("h2", { className: "text-center m-b-l", children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "login.login" }) }), (0, jsx_runtime_1.jsx)(login_form_1.default, { loginError: loginError, onSubmit: onSubmit, showApplicantRegistrationButton: true, showCompanyRegistrationButton: false, onOAuthSuccess: onOAuthSuccess })] }) }));
}
